export const transitions = {
  delay: {
    shortest: 100,
  },
};

export type DecisionsTransitions = typeof transitions;
